module.exports = __webpack_public_path__ + "static/media/api.65cbf540.png";